// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconCusd } from "../../../icons/mono/build/icon-cusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const CusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconCusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  CusdIcon.displayName = 'CusdIcon';
}

export default CusdIcon;